
import { Component } from 'vue-property-decorator'
import ProductPreview from '@/components/common/ProductPreview.vue'
import FramePuzzlePreview from '@/components/products/framepuzzle/FramePuzzlePreview.vue'

@Component({
    name: "product-preview",
    components: {
        FramePuzzlePreview
    }
})
export default class ProductPreviewImpl extends ProductPreview {

    get activeComponent(): string {
        return "frame-puzzle-preview"
    }
}
